<div class="main-container">
  <div class="login-container">
    <div class="left-container"></div>
    <div class="right-container"></div>
    <div class="sign-container">
      <div class="sign-left-container">

        <div class="p-4 p-md-5 flex-grow-1 form-body">
          <div class="alert alert-success mb-5" *ngIf="successful" role="alert">
              OTP has sent successfully to your Email-Id
          </div>
          <h2>Verify</h2>
          <form [formGroup]="roleOtpData" (ngSubmit)="verifyRole()">

              <div class="row gx-2">
                  <div class="mb-3 col-sm-12">
                      <label class="form-label" for="card-email">Email OTP</label>
                      <input class="form-control" (keypress)="numberOnly($event)"  formControlName="emailotp" type="password"
                          id="card-email" [ngClass]="{
                          'is-invalid': otp.emailotp.invalid && submitted
                      }" />
                      <div *ngIf="otp.emailotp.invalid && submitted"
                          class="invalid-feedback">
                          <div *ngIf="otp.emailotp.errors.required">
                              Email OTP is required.
                          </div>
                      </div>
                  </div>

              </div>
                  <div class="mb-3 col-sm-12">
                      <label class="form-label" for="card-password">Password</label>
                      <input class="form-control" formControlName="password" name="password"
                          [type]="hide ? 'password' : 'text'" id="card-password"
                          [ngClass]="{
                           'is-invalid': otp.password.invalid && submitted
                           }" required />
                      <div *ngIf="otp.password.invalid && submitted"
                          class="invalid-feedback">
                          <div *ngIf="otp.password.errors.required">
                              Password is required.
                          </div>
                      </div>
                      <span class="form-control-feedback" (click)="toggleShow()">
                          <i [ngClass]="hide2 ? 'fa fa-eye-slash':'fa fa-eye'"></i>


                      </span>
                  </div>
                  <div class="mb-3 col-sm-12">
                      <label class="form-label" for="card-confirm-password">Confirm
                          Password</label>
                      <input class="form-control"
                          [type]="hide2 ? 'password' : 'text'"
                          formControlName="ConfirmPassword" autocomplete="on"
                          id="card-confirm-password" [ngClass]="{
                          'is-invalid':
                          otp.ConfirmPassword.invalid && submitted
                      }" required />
                      <div *ngIf="otp.ConfirmPassword.invalid && submitted"
                          class="invalid-feedback">
                          <div *ngIf="otp.ConfirmPassword.errors.required">
                              Password is required.
                          </div>
                          <div *ngIf="otp.ConfirmPassword.errors.confirmedValidator">
                              Password and Confirm Password must be match.
                          </div>
                      </div>
                      <span class="form-control-feedback" (click)="toggleShow2()">
                          <i [ngClass]="hide2 ? 'fa fa-eye-slash':'fa fa-eye'"></i>

                      </span>
                  </div>

              <div class="mb-3">
                  <button class="btn btn-primary d-block w-100 mt-3" type="submit" style="background: #110152;height:40px;"
                      name="submit">
                      Verify
                  </button>
              </div>
          </form>
        </div>

      </div>
      <div class="sign-right-container">
        <img src = "../../../../assets/img/dashboard-party-profiles/login-pic.png" class = "rightImage">
      </div>
    </div>
  </div>
</div>



<!-- <main class="main" id="top">
    <div class="container-fluid">
        <div class="row min-vh-100 flex-center g-0">
            <div class="col-lg-8 col-xxl-7 py-3 position-relative">

                <div class="card overflow-hidden z-index-1">
                    <div class="card-body p-0">
                        <div class="row g-0 h-100">
                            <div class="row g-0 h-100">
                                <div class="col-sm-12 col-md-7 col-lg-7 bg-card-gradient" style="
                              display: flex; align-items: stretch;
                              width:48.8%;
                              height:700px;
                              background-size:contain;
                              background-position: center center;
                              background: linear-gradient(0deg, rgba(17, 1, 82, 0.7), rgba(17, 1, 82, 0.7)), url(../../../assets/img/login-img/8.png);;
                              ">
                                    <div class="position-relative p-3">
                                        <div class="z-index-1 position-relative p-3">

                                            <p class="mt-3 d-flex">
                                                <img src="assets/img/icons/spot-illustrations/new-logo-iceipt.png"
                                                    alt="iceipts logo" width="80" height="80">
                                            </p>
                                            <i class="fas fa-quote-left d-flex mt-5" style="color: #00DAF7;"></i>
                                            <br><br>
                                            <p class="opacity-75 text-white d-flex justify-content-start">
                                                The technology that looks impossible today will<br>be part of our life
                                                tomorrow. Iceipts technology<br>creating difference.
                                            </p>

                                            <p class="opacity-75 text-white d-flex">Sibanee kar</p>
                                        </div>
                                    </div>

                            </div>
                            <div class="col-md-7 d-flex flex-center" style="width: 51.2%">

                                    <div class="p-4 p-md-5 flex-grow-1 form-body">
                                        <div class="alert alert-success mb-5" *ngIf="successful" role="alert">
                                            OTP has sent successfully to your Email-Id
                                        </div>
                                        <h2>Verify</h2>
                                        <form [formGroup]="roleOtpData" (ngSubmit)="verifyRole()">

                                            <div class="row gx-2">
                                                <div class="mb-3 col-sm-12">
                                                    <label class="form-label" for="card-email">Email OTP</label>
                                                    <input class="form-control" (keypress)="numberOnly($event)"  formControlName="emailotp" type="password"
                                                        id="card-email" [ngClass]="{
                                                        'is-invalid': otp.emailotp.invalid && submitted
                                                    }" />
                                                    <div *ngIf="otp.emailotp.invalid && submitted"
                                                        class="invalid-feedback">
                                                        <div *ngIf="otp.emailotp.errors.required">
                                                            Email OTP is required.
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                                <div class="mb-3 col-sm-12">
                                                    <label class="form-label" for="card-password">Password</label>
                                                    <input class="form-control" formControlName="password" name="password"
                                                        [type]="hide ? 'password' : 'text'" id="card-password"
                                                        [ngClass]="{
                                                         'is-invalid': otp.password.invalid && submitted
                                                         }" required />
                                                    <div *ngIf="otp.password.invalid && submitted"
                                                        class="invalid-feedback">
                                                        <div *ngIf="otp.password.errors.required">
                                                            Password is required.
                                                        </div>
                                                    </div>
                                                    <span class="form-control-feedback" (click)="toggleShow()">
                                                        <i [ngClass]="hide2 ? 'fa fa-eye-slash':'fa fa-eye'"></i>


                                                    </span>
                                                </div>
                                                <div class="mb-3 col-sm-12">
                                                    <label class="form-label" for="card-confirm-password">Confirm
                                                        Password</label>
                                                    <input class="form-control"
                                                        [type]="hide2 ? 'password' : 'text'"
                                                        formControlName="ConfirmPassword" autocomplete="on"
                                                        id="card-confirm-password" [ngClass]="{
                                                        'is-invalid':
                                                        otp.ConfirmPassword.invalid && submitted
                                                    }" required />
                                                    <div *ngIf="otp.ConfirmPassword.invalid && submitted"
                                                        class="invalid-feedback">
                                                        <div *ngIf="otp.ConfirmPassword.errors.required">
                                                            Password is required.
                                                        </div>
                                                        <div *ngIf="otp.ConfirmPassword.errors.confirmedValidator">
                                                            Password and Confirm Password must be match.
                                                        </div>
                                                    </div>
                                                    <span class="form-control-feedback" (click)="toggleShow2()">
                                                        <i [ngClass]="hide2 ? 'fa fa-eye-slash':'fa fa-eye'"></i>

                                                    </span>
                                                </div>

                                            <div class="mb-3">
                                                <button class="btn btn-primary d-block w-100 mt-3" type="submit" style="background: #110152;"
                                                    name="submit">
                                                    Verify
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->
